import { makeStyles, Theme } from '@material-ui/core';

export const useStyles = makeStyles(
  ({ custom, shape, palette, breakpoints }: Theme) => ({
    root: {
      display: 'inline-flex',
      alignItems: 'center',
      padding: '5px 8px',
      color: custom.grey[2],
      fontSize: 13,
      lineHeight: '21px',
      cursor: 'pointer',
      fontWeight: 'bold',
      whiteSpace: 'nowrap',
      borderRadius: shape.borderRadius,
      border: 'solid 2px',
      borderColor: custom.grey[0],
      '&:not($readonly):hover': {
        '& $unchecked': {
          '& > *': {
            color: palette.primary.main,
          },
        },
      },
    },
    checked: {
      '& $checkArea': {
        backgroundColor: palette.background.default,
      },
    },
    unchecked: {
      '& $checkArea': {
        color: custom.grey[1],
      },
    },
    checkedTitleSuffix: {
      color: custom.grey[3],
      fontWeight: 400,
    },
    checkArea: {
      backgroundColor: palette.background.default,
      color: palette.primary.main,
      width: 18,
      height: 18,
      marginRight: 5,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      transition: 'all 0.3s ease-in-out',
      flexShrink: 0,
    },
    readonly: {
      cursor: 'default',
      '&$unchecked': {
        backgroundColor: custom.grey[0],
        [breakpoints.down(600)]: {
          backgroundColor: 'transparent',
        },
        '& $checkArea': {
          color: custom.grey[1],
          backgroundColor: custom.grey[0],
          [breakpoints.down(600)]: {
            backgroundColor: 'transparent',
          },
        },
        '& > *': {
          color: custom.grey[1],
        },
      },
    },
    iconMode: {},
  })
);
